import PropTypes from 'prop-types';
import React from 'react';
import {Badge} from 'reactstrap';
import styled from 'styled-components';
import {COLORS} from '../constants';

const BadgeTag = styled(Badge)`
  && {
    background-color: ${COLORS.PINK_TAG};
    color: ${COLORS.WHITE};
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 7px;
    padding-bottom: 7px;
    border-radius: 50px;
    margin: 1px 10px 1px 0;
  }
`;

const DisplayTag = ({tag}) => {
  return (
    <BadgeTag>
      {tag.name}
    </BadgeTag>
  );
};

DisplayTag.propTypes = {
  tag: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default DisplayTag;
